module.exports = __webpack_public_path__ + "img/incomeForecastOrange.0d58e711.png";